import { Outlet } from 'react-router-dom';
import { Container } from '../components/Container';
import styles from './Layout.module.css';
import logo from './Logo.svg';
import { LanguageDropdown } from '@/components/LanguageDropdown';
import { KioskFooter } from '@/components/KioskComponents/KioskFooter';
import { checkIsKiosk } from '@/utils/kiosk';

export const Layout = () => {
  const isKiosk = checkIsKiosk();
  // In kiosk mode the <main> landmark is provided by KioskLayout, so here we
  // only render it for the standalone (non-kiosk) first login flow.
  const content = (
    <>
      <img
        className={styles.backgroundLogo}
        src={logo}
        aria-hidden="true"
        alt=""
      />
      <Outlet />
    </>
  );

  return (
    <Container>
      {isKiosk ? (
        <div className={styles.content}>{content}</div>
      ) : (
        <main className={styles.content}>{content}</main>
      )}
      <LanguageDropdown />

      {isKiosk && <KioskFooter />}
    </Container>
  );
};
